import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {

  companyList = [];
  countryList = [];
  city = [];
  cityList = [];
  currencyList = [];

  model = {
    'table_name': 'branch', 'branch_id': '0', 'company_id': '0', 'branch_name': '', 'branch_name_en': '', 'city_id': '0',
    'branch_address': '', 'branch_email': '', 'branch_site': '', 'branch_tel': '', 'branch_tel2': '',
    'responsible': '', 'responsible_phone': '', 'currency_id': '0', 'comment': ''
  };
  country_model = { 'country_id': '' };

  Success_Msg; Error_Msg; Branch_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<BranchComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Branch_Name_Msg').subscribe((res: string) => {
      this.Branch_Name_Msg = res;
    });

  }

  ngOnInit() {

    if (this.dialog_data != null) {
      this.model = this.dialog_data['0'];
      this.country_model = this.dialog_data['1'];
      if (this.model['comment'] == null)
        this.model['comment'] = '';
    }

    let query1 = this.queryList.all_company;
    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.companyList = data.data['list'];
      });

    let query2 = this.queryList.all_country;
    let obj2 = { cmd: 'getList', query: query2 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query2 = this.queryList.all_city;
    obj2 = { cmd: 'getList', query: query2 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });

    let query3 = this.queryList.all_currency;
    let obj3 = { cmd: 'getList', query: query3 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj3)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.currencyList = data.data['list'];
      });
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.country_model['country_id'])
        this.cityList.push(element);
    });
    console.log(this.model['city_id']);
    console.log(this.cityList);
  }

  add() {
    if (this.model['branch_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['branch_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'branch_id': this.model['branch_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['branch_name'] == '') {
      alert(this.Branch_Name_Msg);
    }

  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
